import { Slot, VisitType } from '../types/catalog'

export const visitTypes: VisitType[] = [
  {
    id: 'troupeau',
    name: 'Découverte du troupeau',
    duration: '1 h 30',
    price: 8,
    description:
      'Audrey vous emmène au pré à la rencontre des brebis mérinos et des chèvres angora, puis à la bergerie.',
    season: 'Toute l’année',
  },
  {
    id: 'tonte',
    name: 'Atelier tonte & tri de la toison',
    duration: '2 h',
    price: 15,
    description:
      'Assistez à une tonte commentée, apprenez à trier une toison et repartez avec une mèche de laine.',
    season: 'Avril à juin',
  },
  {
    id: 'feutrage',
    name: 'Atelier feutrage',
    duration: '2 h 30',
    price: 25,
    description:
      'De la mèche cardée à l’objet fini : réalisez votre pièce en feutre à l’eau. Dès 8 ans.',
    season: 'Toute l’année',
  },
]

export const slotsByDay: Record<string, Slot[]> = {
  default: [
    { time: '10:00', places: 8 },
    { time: '14:00', places: 4 },
    { time: '16:30', places: 0 },
  ],
  weekend: [
    { time: '09:30', places: 12 },
    { time: '11:00', places: 2 },
    { time: '14:00', places: 10 },
    { time: '16:30', places: 6 },
  ],
}
